import { useState } from "react";
import SvgIcon from "@components/ui-kit/svg-icon/SvgIcon";
import SerpDataTable from "../serp-data-table/SerpDataTable";
import SerpDataCard from "../serp-data-card/SerpDataCard";
import "./serp-content.less";

export default function SerpContent() {
  const defaultState = {
    serpPhrase: "",
    serpTableData: [],
    serpCardListData: [],
  };

  const [state] = useState(defaultState);

  return (
    <div className="serp-content-container">
      <div className="serp-phrase">
        <span className="txt">Serp phrase</span>
        <div className="v-line"></div>
        <SvgIcon type="right" />
      </div>

      {/* @ts-ignore */}
      <SerpDataTable tableData={state.tableData} />

      {state.serpCardListData.map((card, i) => (
        <SerpDataCard cardData={card} key={"card-" + i} />
      ))}
    </div>
  );
}
